import { prettifyTransactionControlTypeEnum } from '@src/utils/transactionControlTypeLabels';

export function getLPSettlementTransactionTypeDisplayLabel(transactionType: string | undefined): string {
  return transactionType ? prettifyTransactionControlTypeEnum(transactionType) : '';
}

export function formatUnsettledTransactionsEventIdCell({
  eventId,
  transactionType,
  isGroupedByEventId,
}: {
  eventId: string | undefined;
  transactionType: string | undefined;
  isGroupedByEventId: boolean;
}): string {
  if (isGroupedByEventId) {
    return getLPSettlementTransactionTypeDisplayLabel(transactionType);
  }
  return eventId ?? '';
}
